"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TotalCostHeading = function TotalCostHeading() {
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3
  }, _services.locale.localeString('AccessoryModal.TotalCost'));
};
var PaymentSummary = function PaymentSummary(_ref) {
  var payment = _ref.payment,
    onAdd = _ref.onAdd;
  var breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: true
  }, breakpoints.sm && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    align: "end",
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(TotalCostHeading, null)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    align: "end",
    justify: "center"
  }, !breakpoints.sm && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 7
  }, /*#__PURE__*/_react.default.createElement(TotalCostHeading, null)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, (payment === null || payment === void 0 ? void 0 : payment.upfront) >= 0 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextStack, {
    size: 1,
    level: 2,
    text: {
      main: "".concat(_services.locale.formatPrice(payment.upfront)),
      prefix: "".concat(_services.locale.localeString('AccessoryModal.Upfront'))
    }
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, payment.monthlyPrice && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextStack, {
    size: 1,
    level: 2,
    text: {
      main: "".concat(_services.locale.formatPrice(payment.monthlyPrice)),
      prefix: "".concat(_services.locale.localeString('AccessoryModal.Monthly'))
    }
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 6
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "accessory-button-next",
    width: "full",
    text: _services.locale.localeString('AccessoryModal.ButtonText'),
    appearance: "primary",
    state: "",
    onClick: onAdd
  })))))));
};
var _default = PaymentSummary;
exports.default = _default;